import * as signalR from '@aspnet/signalr'


export default class CarehomeHub {

    public static connection: signalR.HubConnection;

    private StartedAdministrationEvent: (carehomeId: string, patientId: string) => void;
    private StoppedAdministrationEvent: (carehomeId: string, patientId: string) => void;
    private PatientAdministrationChangedEvent: (carehomeId: string, patientId: string) => void;

    public IsConnected: boolean;
    public IsConnecting: boolean;

    private retryCount: number;
    private carehomeId: string;

    public constructor() {
        this.IsConnected = false;

        this.retryCount = 5;

        if (CarehomeHub.connection) {

            CarehomeHub.connection.send("UnSubscribe", this.carehomeId);
            CarehomeHub.connection.stop();
        }

        var builder = new signalR.HubConnectionBuilder().withUrl("/carehomeHub");

        //CarehomeHub.connection = new signalR.HubConnection("/carehomehub", { logger: signalR.LogLevel.Information });
        CarehomeHub.connection = builder.build();
        CarehomeHub.connection.onclose(e => {
            console.log("SignalR CarehomeHub.connection.onclose", e);
            this.TryConnect()
        });

        CarehomeHub.connection.on("CarehomeStartedAdministration", (carehomeId, patientId) => {
            console.log("Hub : CarehomeStartedAdministration ", carehomeId, patientId);
            if (this.StartedAdministrationEvent) {
                this.StartedAdministrationEvent(carehomeId, patientId);
            }
        });

        CarehomeHub.connection.on("CarehomeStoppedAdministration", (carehomeId, patientId) => {
            console.log("Hub : CarehomeStoppedAdministration ", carehomeId, patientId);
            if (this.StoppedAdministrationEvent) {
                this.StoppedAdministrationEvent(carehomeId, patientId);
            }
        });

        CarehomeHub.connection.on("CarehomePatientAdministrationChanged", (carehomeId, patientId) => {
            console.log("Hub : CarehomePatientAdministrationChanged ", carehomeId, patientId);

            if (this.PatientAdministrationChangedEvent) {
                this.PatientAdministrationChangedEvent(carehomeId, patientId);
            }
        });

        this.TryConnect();
    }

    public ResetConnection(carehomeId: string) {

        if (!this.IsConnected && !this.IsConnecting) {
            this.retryCount = 5;
            if (this.carehomeId) {
                CarehomeHub.connection.send("UnSubscribe", this.carehomeId);
            }

            this.carehomeId = carehomeId;
            this.TryConnect();
        }
    }

    private TryConnect() {
        if (!this.carehomeId) {
            console.log("SignalR Trying to connect to undefined carehome ");
            return;
        }

        console.log("Trying to connect to SignalR. Attempt : " + (+5 - this.retryCount));
        this.IsConnecting = true;

        if (this.retryCount > 0) {
            CarehomeHub.connection
                .start()
                .then(() => {
                    this.IsConnected = true;
                    this.IsConnecting = false;
                    this.retryCount = 5;

                    console.log("Subscribing to Carehome Id : " + this.carehomeId);
                    CarehomeHub.connection.send("Subscribe", this.carehomeId);
                })
                .catch(err => {
                    console.log("Failed Connection");
                    this.IsConnected = false;
                    this.retryCount = this.retryCount - 1;

                    console.log(err);

                    //if (this.retryCount>= 1) {
                    //    setTimeout(() => this.TryConnect(), 2000);
                    //}
                    //else 
                    //{
                    console.log("Retries Exhaused - Stopping attempts to connect ");
                    this.IsConnecting = false;
                    //}
                });
        }
    }

    public Dispose() {

        if (CarehomeHub.connection) {
            CarehomeHub.connection.stop();
        }
    }
    public OnStartedAdministration(callback: (carehomeId: string, patientId: string) => void) {
        this.StartedAdministrationEvent = callback;
    }
    public OnStoppedAdministration(callback: (carehomeId: string, patientId: string) => void) {
        this.StoppedAdministrationEvent = callback;
    }
    public OnPatientAdministrationChanged(callback: (carehomeId: string, patientId: string) => void) {
        this.PatientAdministrationChangedEvent = callback;
    }
}


// WEBPACK FOOTER //
// ./ClientApp/components/pages/carehome-dispensation/CarehomeHub.ts